import { useNavigate } from 'react-router-dom';

import MeetingIcon from '@lib/core/src/assets/empty-state-icons/meetings.svg?react';
import MeetingSvg from '@lib/core/src/assets/images/meetings-widget.svg';
import { EmptyState } from '@lib/core/src/components/EmptyState';
import Skeleton from '@lib/core/src/components/Skeleton';
import { H2 } from '@lib/core/src/styledComponents/StyledComponents';

import { CalendarMeetingInfoDto } from '@/api/generated';
import RoutesMap from '@/enums/RoutesMap';
import { ViewAllButton } from '@/pages/HomePage/HomeStyles';
import {
  Container,
  Row,
  TitleContainer,
  RightContainer,
  ImageContainer,
  TitleAndViewAllContainer,
  Image,
  ScrollContainer
} from '@/pages/HomePage/components/CalendarMeetingsStyles';

import useMeetingsViewLogic from './hooks/useMeetingsViewLogic';
import MeetingRow from './meetingRow/MeetingRow';

const MeetingsView = () => {
  const { meetings, loading } = useMeetingsViewLogic();

  const navigate = useNavigate();

  return (
    <Container>
      <TitleAndViewAllContainer>
        <TitleContainer>
          <Row>
            <H2>Last meetings</H2>
            <ViewAllButton onClick={() => navigate(RoutesMap.MeetingHub)}>View all</ViewAllButton>
          </Row>
        </TitleContainer>
        <ImageContainer>
          <Image imageUrl={MeetingSvg} />
        </ImageContainer>
      </TitleAndViewAllContainer>
      <RightContainer>
        <ScrollContainer>
          {loading ? <Skeleton count={4} /> : <RenderMeetings meetings={meetings} />}
        </ScrollContainer>
      </RightContainer>
    </Container>
  );
};

export default MeetingsView;

const RenderMeetings = ({ meetings }: { meetings: CalendarMeetingInfoDto[] }) => {
  if (meetings.length === 0) {
    return <EmptyState text="No meetings" icon={<MeetingIcon />} />;
  }

  return meetings.map(meeting => <MeetingRow key={meeting.id} meeting={meeting} />);
};
